import { LocationOn } from '@mui/icons-material';
import LanguageIcon from '@mui/icons-material/Language';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import {
  AppBar,
  Badge,
  Box,
  CssBaseline,
  Fab,
  Grid,
  Icon,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import CALL_ICON from '../../static/images/call_icon.png';
import HELP_ICON from '../../static/images/help_icon.png';
import LanguageButtonIcon from '../../static/images/language_icon.png';
import MAP_ICON from '../../static/images/map_icon.png';
import CI from '../../static/images/smart_order_ci.png';
import CI_EN from '../../static/images/smart_order_ci_en.png';
import Progress from '../common/Progress';
import StoreMap from '../common/StoreMap';
import Category from './Category';
import LanguageModal from './LanguageModal';
import MenuList from './MenuList';
import SetItemModal from './SetItemModal';

@inject('commonStore', 'menuStore', 'cartStore')
@observer
class Main extends Component {
  componentDidMount() {
    const { commonStore, match, history, location } = this.props;

    if (history.length === 0) {
      history.push(`/${match.params.companyId.toLowerCase()}/${match.params.storeCode}${location.search}`);
    }

    commonStore.setData(match.params.companyId.toLowerCase(), match.params.storeCode);
  }

  // 메뉴 아이콘 클릭
  handleClickMenu = event => {
    const { commonStore } = this.props;
    commonStore.menuAnchorEl = event.currentTarget;
  };

  // 메뉴 창 닫기
  handleCloseMenu = () => {
    const { commonStore } = this.props;
    commonStore.menuAnchorEl = null;
  };

  // 전화하기
  handleClickCall = () => {
    const { commonStore, menuStore } = this.props;
    commonStore.menuAnchorEl = null;
    document.location.href = `tel:${menuStore.storeData.storePhone}`;
  };

  // 매장위치
  handleClickMap = () => {
    const { commonStore, menuStore } = this.props;
    commonStore.menuAnchorEl = null;

    // 매장 선택
    commonStore.setMap(
      menuStore.storeData.storeName,
      menuStore.storeData.storeAddress1,
      menuStore.storeData.storeAddress2,
      menuStore.storeData.storePhone,
    );

    // 지도 Modal 오픈
    commonStore.setMapOpen(true);
  };

  // 사용안내
  handleClickUserGuide = () => {
    const { history, location, commonStore } = this.props;
    commonStore.menuAnchorEl = null;
    history.push(`/${commonStore.companyId}/${commonStore.storeCode}/user-guide${location.search}`);
  };

  /** 언어 변경 버튼 클릭 */
  handleLanguageButtonClick = () => {
    this.props.commonStore.setLanguageDialogOpen(true);
    this.handleCloseMenu();
  };

  // 장바구니
  handleClickCart = () => {
    const { history, location, commonStore, cartStore, t } = this.props;

    if (!cartStore.cartData.menus.length === 0) {
      commonStore.setSnackbar(true, t('cart.error.empty'));
      return;
    }

    history.push(`/${commonStore.companyId}/${commonStore.storeCode}/cart${location.search}`);
  };

  handleNotationClick = () => {
    const { history, location, commonStore } = this.props;
    history.push(`/${commonStore.companyId}/${commonStore.storeCode}/notation${location.search}`);
  };

  render() {
    const { commonStore, menuStore, cartStore, t, match, location } = this.props;
    if (!menuStore.storeData) return <Progress />;
    return (
      <Fragment>
        <CssBaseline />
        <AppBar position="fixed" color="primary" style={{ boxShadow: 'none', zIndex: 1 }}>
          <Toolbar style={{ minHeight: '60px' }}>
            {/* 매장명 */}
            <Icon edge="start" style={{ marginRight: '10px' }}>
              <LocationOn />
            </Icon>
            <div className="title">{menuStore.storeData.storeName}</div>

            {/** 메뉴 아이콘 버튼 */}
            <IconButton edge="end" color="inherit" onClick={this.handleClickMenu} size="large">
              <MenuRoundedIcon fontSize={'large'} />
            </IconButton>
          </Toolbar>

          {/** 메뉴 카테고리 */}
          <Category />
        </AppBar>
        <Box className="contents-main">
          <Box className="menu-container">
            {/* 메뉴 리스트 */}
            {!menuStore.filterdMenuGroups || menuStore.filterdMenuGroups.length === 0 ? (
              <Typography align="center" style={{ paddingTop: '20px' }}>
                {t('menu.text.empty')}
              </Typography>
            ) : (
              <MenuList />
            )}
            {/* 장바구니 버튼 */}
            {cartStore.totalCnt > 0 && (
              <Fab color="primary" variant="extended" onClick={this.handleClickCart} className="button-order">
                <Badge badgeContent={cartStore.totalCnt}>
                  <span>{t('order.button.order')}</span>
                </Badge>
              </Fab>
            )}

            {menuStore.storeData.isLangButtonUsed && (
              <div className="language-button" onClick={this.handleLanguageButtonClick}>
                <img src={LanguageButtonIcon} alt="언어변경 버튼" />
              </div>
            )}
          </Box>
          <Box component="footer" className="footer-main">
            <Grid container>
              <Grid item style={{ padding: '15px 10px 0 0' }}>
                <img src={menuStore.storeData.culture === 'ko-KR' ? CI : CI_EN} width="60px" alt="IMU" />
              </Grid>
              <Grid item container xs direction="column" spacing={1} style={{ fontSize: '10pt' }}>
                {menuStore.storeData.culture === 'ko-KR' && (
                  <Grid item style={{ borderBottom: '1px dashed #a2a2a2' }}>
                    <b>{t('shop.label.serviceProvider')}</b>
                    <br />
                    {t('shop.label.name')}: (주)아임유
                    <br />
                    {t('shop.label.representative')}: 최재섭
                    <br />
                    {t('shop.label.businessNumber')}: 108-81-93646
                    <br />
                    서울 금천구 가산디지털2로 115 609호
                    <br />
                    {t('shop.label.phone')}: 1566-4574
                  </Grid>
                )}
                {menuStore.storeData.culture === 'ja-JP' ? (
                  <>
                    <Grid item>
                      <b>{t('shop.label.seller')}</b>
                      <br />
                      {t('shop.label.name')}: {menuStore.storeData.storeName}
                      <br />
                      {menuStore.storeData.storeAddress1} {menuStore.storeData.storeAddress2}
                      <br />
                      {t('shop.label.phone')}: {menuStore.storeData.storePhone}
                    </Grid>
                    {menuStore.storeData.notation && (
                      <Grid item>
                        <Link
                          to={`/${match.params.companyId.toLowerCase()}/${match.params.storeCode}/notation${
                            location.search
                          }`}
                        >
                          {t('common.label.commerceInfo')}
                        </Link>
                      </Grid>
                    )}
                  </>
                ) : (
                  <Grid item>
                    <b>{t('shop.label.seller')}</b>
                    <br />
                    {t('shop.label.name')}: {menuStore.storeData.storeName}
                    <br />
                    {t('shop.label.representative')}: {menuStore.storeData.storeCEO}
                    <br />
                    {t('shop.label.businessNumber')}: {menuStore.storeData.businessNumber}
                    <br />
                    {menuStore.storeData.storeAddress1} {menuStore.storeData.storeAddress2}
                    <br />
                    {t('shop.label.phone')}: {menuStore.storeData.storePhone}
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Menu
          id="simple-menu"
          keepMounted
          anchorEl={commonStore.menuAnchorEl}
          open={Boolean(commonStore.menuAnchorEl)}
          onClose={this.handleCloseMenu}
        >
          <MenuItem onClick={this.handleClickCall}>
            <div className="menu-icon">
              <img src={CALL_ICON} alt={t('shop.button.call')} style={{ width: '14px' }} />
            </div>
            {t('shop.button.call')}
          </MenuItem>
          {menuStore.storeData.culture === 'ko-KR' && (
            <MenuItem onClick={this.handleClickMap}>
              <div className="menu-icon">
                <img src={MAP_ICON} alt={t('shop.button.location')} style={{ width: '14px' }} />
              </div>
              {t('shop.button.location')}
            </MenuItem>
          )}
          {menuStore.storeData.culture === 'ko-KR' && (
            <MenuItem onClick={this.handleClickUserGuide}>
              <div className="menu-icon">
                <img src={HELP_ICON} alt={t('common.button.guide')} style={{ width: '14px' }} />
              </div>
              {t('common.button.guide')}
            </MenuItem>
          )}
          <MenuItem onClick={this.handleLanguageButtonClick}>
            <LanguageIcon fontSize="small" style={{ color: '#F2086B', marginRight: '10px', width: '17px' }} />
            {t('common.button.changeLanguage')}
          </MenuItem>
        </Menu>

        {/* 일반메뉴, 세트메뉴 선택 모달 */}
        {menuStore.isSetItemModalOpen && <SetItemModal />}

        {/* 지도보기 MODAL */}
        <StoreMap />

        {/* 언어 변경 MODAL */}
        <LanguageModal />
      </Fragment>
    );
  }
}

export default withRouter(withTranslation()(Main));
